export default "__VITE_ASSET__BCICKYNJ__"